import { LockKeyIcon } from '@phosphor-icons/react';
import { Link } from 'react-router';
import type { EnableCapabilitySignalData } from './tool-signals';

/**
 * FRONT-847 (Task 8): renders a `data-enable-capability` signal inline in the
 * assistant message. This case is different from `data-connect-integration`
 * — the provider connection already exists, but the capability/tool the
 * agent needs isn't enabled for this user yet. There's no OAuth popup or
 * retry to wire up here; this is a compact pointer to where the user can
 * turn the capability on (the Connections page).
 */
export function EnableCapabilityCard({ capabilities }: EnableCapabilitySignalData) {
  if (!capabilities || capabilities.length === 0) return null;

  return (
    <div className="flex items-center gap-2 px-3 py-2 border border-border rounded-lg bg-card max-w-[85%]">
      <LockKeyIcon size={16} className="shrink-0 text-muted-foreground" />
      <div className="flex-1 min-w-0 text-xs text-foreground">
        <span>
          This provider is connected, but{' '}
          <span className="font-medium">{capabilities.join(', ')}</span> still needs to be
          enabled before the agent can use it.
        </span>{' '}
        <Link to="/system-settings?section=connections" className="text-primary hover:underline">
          Enable in Connections
        </Link>
      </div>
    </div>
  );
}
